import { computeRawSummaryAt } from '../Meshes/Meshes';
import { useViewportInfoBox } from '../ViewportInfoBox/ViewportInfoBox';

function summaryAt(meshes, threshold) {
    const stats = meshes?.rawTriangleStats;
    if (!stats) return null;
    return computeRawSummaryAt(stats, threshold);
}

export function useRawMapSummary(containerRef, initialized, isVisible, meshes, threshold) {
    const summary = summaryAt(meshes, threshold);
    const rows = [
        { label: 'RAW Surface Coverage', value: summary ? `${summary.rawCoveragePct.toFixed(2)}%` : '--' },
        { label: 'RAW Surface Area', value: summary ? `${summary.rawSurfaceAreaCm2.toFixed(2)} cm²` : '--' },
    ];
    useViewportInfoBox(containerRef, initialized, isVisible, { title: 'Raw Map Summary', rows });
}
